module.exports = __webpack_public_path__ + "static/background-camping-11ec63b4107d59ba4730e5e103612d92.jpg";